import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import ToggleSwitch from "../../components/ToggleSwitch/ToggleSwitch";
import ReactSlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import {
  useCreateOrUpdateSalaryComponents,
  useViewStatutoryComponents,
} from "../../queries/payrollQuries";
import { toast } from "react-toastify";
import { closeIcon } from "../../Icons/Icons";
import {
  calculationFromOptions,
  componentTypeOptions,
  calculationTypeOptions,
} from "../../utils/commonSelectBoxOptions/commonSelectBoxOptions";
import {
  SALARY_COMPONENT_CALCULATION,
  SALARY_COMPONENT_TYPES,
} from "../../../src/redux/constants/payrollComponents";
import { Tooltip } from "antd";
import { infoIcon } from "../../Icons/Icons";

const AddSalaryComponent = ({
  closePane,
  selectedTabIndex,
  editData,
  hasBaseComponent,
}) => {
  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      componentName: editData?.earning_type || "",
      to_be_calculated_value: editData?.to_be_calculated_value || "",

      calculationType: editData
        ? calculationTypeOptions.find(
            (opt) => opt.value === Number(editData?.calculation_type)
          )
        : null,

      calculationFrom: editData
        ? calculationFromOptions.find(
            (opt) => opt.value === Number(editData?.calculated_from_value)
          )
        : null,
      description: editData?.component_description || "",
    },
  });

  const [isActive, setIsActive] = useState(
    editData?.is_active === true || editData?.is_active === "true"
  );
  const [isFixed, setIsFixed] = useState(editData?.is_fixed === true);
  const [isHideInPayslip, setIsHideInPayslip] = useState(
    editData?.hide_in_payslip === true
  );
  const [isBase, setIsBase] = useState(editData?.is_basic === true);

  // Statutory Components
  const { data, isLoading, error } = useViewStatutoryComponents();
  const mandatoryStatutoryComponents =
    data?.data?.filter((item) => item.is_active === true) || [];
  const [selectedStatutoryComponentIds, setSelectedStatutoryComponentIds] =
    useState([]);
  useEffect(() => {
    if (editData?.statutory_component_ids?.length > 0) {
      setSelectedStatutoryComponentIds(editData.statutory_component_ids);
    }
  }, [editData]);

  const handleStatutoryCheckboxChange = (id) => {
    if (id == null) return;
    const numericId = Number(id);
    setSelectedStatutoryComponentIds((prev) =>
      prev.includes(numericId)
        ? prev.filter((item) => item !== numericId)
        : [...prev, numericId]
    );
  };
  // const componentType = selectedTabIndex === 0 ? 2 : 1;
  const [componentType, setComponentType] = useState(
    componentTypeOptions.find(
      (opt) =>
        opt.value ===
        (selectedTabIndex === 0
          ? SALARY_COMPONENT_TYPES.EARNING
          : SALARY_COMPONENT_TYPES.DEDUCTION)
    )
  );
  const createSalaryComponent = useCreateOrUpdateSalaryComponents();
  const selectedCalculationType = watch("calculationType");

  const getValueLabel = () => {
    if (
      Number(selectedCalculationType?.value) ===
      Number(SALARY_COMPONENT_CALCULATION.PERCENTAGE)
    ) {
      return "Percentage (%)";
    }
    return "Fixed Amount";
  };

  const onSubmit = (data) => {
    const payload = {
      component_name: data.componentName,
      to_be_calculated_value: parseFloat(data.to_be_calculated_value),
      calculation_type: parseInt(data.calculationType.value),
      component_type: componentType.value,
      hide_in_payslip: isHideInPayslip.toString(),
      is_active: isActive.toString(),
      is_fixed: isFixed.toString(),
      is_basic: isBase.toString(),
      component_description: data.description,
      statutory_component_ids: selectedStatutoryComponentIds.filter(
        (id) => id != null
      ),
    };

    if (data.calculationFrom) {
      payload.calculated_from = data.calculationFrom.label;
      payload.calculated_from_value = parseInt(data.calculationFrom.value);
    }

    if (editData?.salary_component_id) {
      payload.salary_component_id = editData.salary_component_id;
    }

    createSalaryComponent.mutate(payload, {
      onSuccess: (response) => {
        if (response.status) {
          toast.success(
            response.message || "Salary component updated successfully"
          );
          closePane();
        } else {
          toast.error(response.message || "Failed to update salary component");
        }
      },
      onError: (error) => {
        const errorMessage =
          error?.response?.data?.message ||
          "Error while creating salary component";
        toast.error(errorMessage);
      },
    });
  };

  return (
    <ReactSlidingPane isOpen onRequestClose={closePane} width="450px">
      <div className="flex justify-between items-center px-5 border-b py-3">
        <h1 className="font-medium">
          {editData ? "Edit" : "Add"} Salary Component
        </h1>
        <button onClick={closePane}>{closeIcon}</button>
      </div>
      <div className="p-4">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-4">
            <div className="flex items-center gap-1">
              <label className="block text-sm font-medium">
                Component Type
              </label>
              <Tooltip title="Select whether this is an earning or deduction component.">
                <span className="cursor-pointer">{infoIcon}</span>
              </Tooltip>
            </div>
            <Select
              options={componentTypeOptions.filter(
                (opt) => opt.label !== "TDS"
              )}
              value={componentType}
              onChange={(selected) => setComponentType(selected)}
              placeholder="Select Component Type"
            />
          </div>

          <div className="mb-4">
            <div className="flex items-center gap-1">
              <label className="block text-sm font-medium">
                Component Name
              </label>
              <Tooltip title="Enter the name of the salary component (e.g., HRA, Bonus, PF).">
                <span className="cursor-pointer">{infoIcon}</span>
              </Tooltip>
            </div>
            <input
              type="text"
              className="border p-2 w-full"
              {...register("componentName", {
                required: "This field is required",
              })}
            />
            {errors.componentName && (
              <p className="text-red-500 text-xs">
                {errors.componentName.message}
              </p>
            )}
          </div>

          <div className="mb-4">
            <div className="flex items-center gap-1">
              <label className="block text-sm font-medium">
                Calculation Type
              </label>
              <Tooltip title="Choose how this component's amount should be calculated (e.g., fixed, percentage, or auto).">
                <span className="cursor-pointer">{infoIcon}</span>
              </Tooltip>
            </div>

            <Controller
              name="calculationType"
              control={control}
              rules={{ required: "This field is required" }}
              render={({ field }) => (
                <Select
                  {...field}
                  options={calculationTypeOptions}
                  placeholder="Select Calculation Type"
                />
              )}
            />

            {errors.calculationType && (
              <p className="text-red-500 text-xs">
                {errors.calculationType.message}
              </p>
            )}
          </div>
          {selectedCalculationType &&
            (Number(selectedCalculationType?.value) ===
            Number(SALARY_COMPONENT_CALCULATION.AUTO_CALCULATED) ? (
              <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 mb-4 text-sm rounded">
                <p>
                  <strong>Note:</strong> This component is automatically
                  calculated as part of the payroll structure.
                </p>
              </div>
            ) : (
              <div className="mb-4">
                <label className="block text-sm font-medium">
                  Calculation Based on ({getValueLabel()})
                </label>
                <input
                  type="number"
                  step="0.01"
                  className="border p-2 w-full"
                  {...register("to_be_calculated_value", {
                    required: "This field is required",
                    valueAsNumber: true,
                    validate: (value) => {
                      if (
                        Number(selectedCalculationType?.value) ===
                        SALARY_COMPONENT_CALCULATION.PERCENTAGE
                      ) {
                        return (
                          (value >= 0 && value <= 100) ||
                          "Percentage must be between 0 and 100"
                        );
                      }
                      return true;
                    },
                  })}
                />
                {errors.to_be_calculated_value && (
                  <p className="text-red-500 text-xs">
                    {errors.to_be_calculated_value.message}
                  </p>
                )}
              </div>
            ))}

          {/* is calulation type != auto  then clayted from */}
          {selectedCalculationType &&
            Number(selectedCalculationType?.value) !==
              Number(SALARY_COMPONENT_CALCULATION.AUTO_CALCULATED) && (
              <div className="mb-4">
                <div className="flex items-center gap-1">
                  <label className="block text-sm font-medium">
                    Calculation From
                  </label>
                  <Tooltip title="Select the base component or value from which this component will be calculated.">
                    <span className="cursor-pointer">{infoIcon}</span>
                  </Tooltip>
                </div>

                <Controller
                  name="calculationFrom"
                  control={control}
                  defaultValue={
                    editData?.calculated_from_value
                      ? calculationFromOptions.find(
                          (opt) =>
                            opt.value ===
                            Number(editData?.calculated_from_value)
                        )
                      : null
                  }
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={calculationFromOptions}
                      placeholder="Select Calculation From"
                      value={
                        field.value
                          ? calculationFromOptions.find(
                              (opt) =>
                                opt.value ===
                                Number(field.value?.value || field.value)
                            )
                          : null
                      }
                      onChange={(selected) => {
                        // Keep consistent structure — either object or null
                        field.onChange(selected ? selected : null);
                      }}
                    />
                  )}
                />

                {errors.calculationFrom && (
                  <p className="text-red-500 text-xs">
                    {errors.calculationFrom.message}
                  </p>
                )}
              </div>
            )}
          {/*Statutory Components Section */}

          <div className="mb-4">
            <div className="flex items-center gap-1">
              <label className="block text-sm font-medium">
                Applicable Statutory Components
              </label>
              <Tooltip title="Choose the applicable statutory components that this salary component should be considered for.">
                <span className="cursor-pointer">{infoIcon}</span>
              </Tooltip>
            </div>
            {isLoading ? (
              <p>Loading statutory components...</p>
            ) : (
              <Select
                isMulti
                options={mandatoryStatutoryComponents.map((component) => ({
                  value: component.component_id,
                  label: component.component_name,
                }))}
                value={mandatoryStatutoryComponents
                  .filter((comp) =>
                    selectedStatutoryComponentIds.includes(comp.component_id)
                  )
                  .map((comp) => ({
                    value: comp.component_id,
                    label: comp.component_name,
                  }))}
                onChange={(selectedOptions) => {
                  setSelectedStatutoryComponentIds(
                    selectedOptions.map((option) => option.value)
                  );
                }}
                placeholder="Select statutory components"
              />
            )}
          </div>

          <div className="mb-4 flex items-center justify-between">
            <div className="flex items-center gap-1">
              <label className="block text-sm font-medium">Is Fixed</label>
              <Tooltip title="If enabled, this component amount will remain fixed and will be considered during payroll calculation to adjust the Special Allowance accordingly.">
                <span className="cursor-pointer">{infoIcon}</span>
              </Tooltip>
            </div>
            <ToggleSwitch checked={isFixed} getToggleState={setIsFixed} />
          </div>

          <div className="mb-4 flex items-center justify-between">
            <div className="flex items-center gap-1">
              <label className="block text-sm font-medium">Is Base</label>
              <Tooltip title="Enable this to mark this component as the base. Only one component can be marked as base at a time.">
                <span className="cursor-pointer">{infoIcon}</span>
              </Tooltip>
            </div>
            <ToggleSwitch
              checked={isBase}
              getToggleState={setIsBase}
              disabled={hasBaseComponent && !editData?.is_basic}
            />
          </div>

          <div className="mb-4 flex items-center justify-between">
            <div className="flex items-center gap-1">
              <label className="block text-sm font-medium">Is Active</label>
              <Tooltip title="Enable to make this component available for salary calculations.">
                <span className="cursor-pointer">{infoIcon}</span>
              </Tooltip>
            </div>
            <ToggleSwitch checked={isActive} getToggleState={setIsActive} />
          </div>

          <div className="mb-4 flex items-center justify-between">
            <div className="flex items-center gap-1">
              <label className="block text-sm font-medium">
                Hide In Payslip
              </label>
              <Tooltip title="Enable this to hide the component from the employee's payslip.">
                <span className="cursor-pointer">{infoIcon}</span>
              </Tooltip>
            </div>
            <ToggleSwitch
              checked={isHideInPayslip}
              getToggleState={setIsHideInPayslip}
            />
          </div>

          <div className="mb-4">
            <div className="flex items-center gap-1">
              <label className="block text-sm font-medium">Description</label>
              <Tooltip title="Add a short description or note about this salary component.">
                <span className="cursor-pointer">{infoIcon}</span>
              </Tooltip>
            </div>
            <textarea
              className="border p-2 w-full"
              {...register("description", {
                required: "This field is required",
              })}
            />
            {errors.description && (
              <p className="text-red-500 text-xs">
                {errors.description.message}
              </p>
            )}
          </div>

          <div className="flex gap-4">
            <button
              type="button"
              className="bg-gray-500 text-white px-4 py-2 rounded"
              onClick={closePane}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-500 text-white px-4 py-2 rounded"
              disabled={createSalaryComponent.isLoading}
            >
              {createSalaryComponent.isLoading
                ? editData
                  ? "Updating..."
                  : "Adding..."
                : editData
                ? "Update"
                : "Add"}{" "}
              Salary Component
            </button>
          </div>
        </form>
      </div>
    </ReactSlidingPane>
  );
};

export default AddSalaryComponent;
